export default "__VITE_PUBLIC_ASSET__d37b6aea__"